import React, { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { useNavigate } from "react-router-dom"
import GoBack from "../subsidiary/GoBack/GoBack"
import Loader from "../subsidiary/Loader/Loader"
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import styles from './Settings.module.css'
import Button from '@mui/material/Button'
import { useDispatch, useSelector } from 'react-redux'
import { changeEmail, getUserData } from '../Profile/profileSlice'
import InputMask from "react-input-mask";
import { sendSms, setUserNumber } from "../Login/loginSlice"

const Settings = () => {
    const [isLoaded, setIsLoaded] = useState(false)
    const [email, setEmail] = useState('')
    const [emailDirty, setEmailDirty] = useState(false)
    const [emailError, setEmailError] = useState('')
    const [formValid, setFormValid] = useState(false)
    const [phoneNumber, setPhoneNumber] = useState('')
    const [mascedInput, setMascedInput] = useState(null)
    const [title, setTitle] = useState('')
    const settingType = useParams().type
    const dispatch = useDispatch()
    const navigation = useNavigate()
    const user = useSelector(state => state.profileSlice.user)
    const emailHandler = (e) => {
        setEmail(e.target.value)
        const reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/
        if (!reg.test(String(e.target.value).toLowerCase())) {
            setEmailError('Некорректный email')
            setEmailDirty(true)
        } else {
            setEmailError('')
        }
    }

    const submitHandler = () => {
        if (settingType === 'email') {
            dispatch(changeEmail({ email })).then(() => {
                dispatch(getUserData())
                window.showAlert({ title: 'Почта изменена успешно', type: 'success' })
                navigation('/profile')
            })

        }

        else if (settingType === 'phone') {
            dispatch(sendSms({ phoneNumber: mascedInput })).then((params) => {
                if (!params.error) {
                    dispatch(setUserNumber(mascedInput))
                    navigation('sms')
                    window.showAlert({ title: 'Сейчас вам поступит звонок, потребуется ввести последние 4 цифры номера', type: 'success' })
                }
            })
        }
    }
    const phoneHandler = (e) => {
        setPhoneNumber(e.target.value)
        setMascedInput(e.target.value.trim().replace(/[^0-9]/g, ''))
    }
    useEffect(() => {
        if (emailError) {
            setFormValid(false)
        } else {
            setFormValid(true)
        }

    }, [emailError])

    useEffect(() => {
        if (settingType === 'email') {
            setTitle('адрес электронной почты')
        }
        else if (settingType === 'phone') {
            setTitle('номер телефона')
        }
        else if (settingType === 'password') {
            setTitle('пароль')
        }
        return () => { setTitle('') }
    }, [settingType])

    return (
        <section className={'main'}>
            {<>
                <GoBack text='Назад' />
                <div className="content-wrapper">
                    <div className="page-title-container">
                        <h1 className="page-title ">
                            Изменить {title}
                        </h1>
                    </div>
                    <div>
                        <FormControl className={styles.formCtrl} >
                            {settingType !== 'password' ?
                                <>
                                    {settingType === 'email' ? <TextField error onChange={e => emailHandler(e)} value={email} id={settingType} label={emailDirty ? emailError : `Введите email`} placeholder={user.email} variant="outlined" /> : null}
                                    {settingType === 'phone' ?
                                        <InputMask
                                            onChange={phoneHandler}
                                            mask="+7 (***) *** ** **"
                                            value={phoneNumber}
                                            disabled={false}
                                            maskChar=" "
                                        >
                                            {() => <TextField error label={`Введите ${title}`} placeholder={user.phoneNumber} variant="outlined" />}
                                        </InputMask> : null}
                                </> : <>
                                    <TextField style={{ marginBottom: '20px' }} type={'password'} id={settingType + '-old'} label={`Старый пароль`} placeholder="" variant="outlined" />
                                    <TextField style={{ marginBottom: '20px' }} type={'password'} id={settingType + '-new'} label={`Новый пароль`} placeholder="" variant="outlined" />
                                    <TextField type={'password'} id={settingType + '-repeat-new'} label={`Повторите новый пароль`} placeholder="" variant="outlined" />
                                </>
                            }
                            <Button onClick={submitHandler} disabled={!formValid} className={styles.sendBtn} variant="contained">Сохранить</Button>
                        </FormControl>
                    </div>
                </div>
            </>}
        </section>
    )
}
export default Settings
